"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconTriangleRightSvg = function IconTriangleRightSvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0l7.84 8L0 16V0z",
    fill: "currentColor"
  }));
};

IconTriangleRightSvg.defaultProps = {
  viewBox: "0 0 8 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IconTriangleRight = function IconTriangleRight(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray800' : _ref$color,
      measure = _ref.measure,
      rest = _objectWithoutProperties(_ref, ["color", "measure"]);

  return /*#__PURE__*/_react.default.createElement(_index.IconStyled, _extends({
    $color: color,
    $measure: measure
  }, rest), /*#__PURE__*/_react.default.createElement(IconTriangleRightSvg, null));
};

IconTriangleRight.displayName = 'IconTriangleRight';
var _default = IconTriangleRight;
exports.default = _default;